import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	'1.4.0': {
		id: 'legal.shipping.title.1.4.0',
		defaultMessage: 'Taxes',
		description: 'Taxes.',
	},
	'1.1.0': {
		id: 'legal.shipping.title.1.1.0',
		defaultMessage: 'Order and Shipping Confirmation',
		description: 'Order and Shipping Confirmation',
	},
	'1.0.0': {
		id: 'legal.shipping.title.1.0.0',
		defaultMessage: 'Shipping Terms',
		description: 'Shipping Terms',
	},
	'0.0.0': {
		id: 'legal.shipping.title.0.0.0',
		defaultMessage: 'Shipping Terms & Return Policy',
		description: 'Shipping Terms & Return Policy',
	},
	'3.0.0': {
		id: 'legal.shipping.title.3.0.0',
		defaultMessage: 'Contact Information',
		description: 'Contact Information',
	},
	'2.0.0': {
		id: 'legal.shipping.title.2.0.0',
		defaultMessage: 'Return Policy',
		description: 'Return Policy',
	},
	'2.3.0': {
		id: 'legal.shipping.title.2.3.0',
		defaultMessage: 'Receiving a Refund',
		description: 'Receiving a Refund',
	},
	'1.3.0': {
		id: 'legal.shipping.title.1.3.0',
		defaultMessage: 'Shipping Costs',
		description: 'Shipping Costs',
	},
	'2.2.0': {
		id: 'legal.shipping.title.2.2.0',
		defaultMessage: 'Late Returns',
		description: 'Late Returns',
	},
	'1.2.0': {
		id: 'legal.shipping.title.1.2.0',
		defaultMessage: 'Where We Ship',
		description: 'Where We Ship',
	},
	'legal.shipping.content.1.1.0': {
		id: 'legal.shipping.content.1.1.0',
		defaultMessage:
			'You will receive an email confirmation once your order has been successfully placed, it will include your order number and shipping method. Please make sure your shipping address is correct as we are unable to redirect goods once they are on route to you. Orders can take up to 2 business days to be processed and shipped. Once your order is prepared for shipment you will receive a shipping confirmation email with your tracking information, if applicable.',
		description:
			'You will receive an email confirmation once your order has been successfully placed, it will include your order number and shipping method. Please make sure your shipping address is correct as we are unable to redirect goods once they are on route to you. Orders can take up to 2 business days to be processed and shipped. Once your order is prepared for shipment you will receive a shipping confirmation email with your tracking information, if applicable.',
	},
	'legal.shipping.content.1.2.0': {
		id: 'legal.shipping.content.1.2.0',
		defaultMessage:
			'We currently ship from our warehouse in Austin, Texas to over 30 countries. We offer free shipping in the U.S. and options for international.',
		description:
			'We currently ship from our warehouse in Austin, Texas to over 30 countries. We offer free shipping in the U.S. and options for international.',
	},
	'legal.shipping.country.unitedStates': {
		id: 'legal.shipping.country.unitedStates',
		defaultMessage: 'U.S.',
		description: 'U.S.',
	},
	'legal.shipping.domesticShipping.standardShipping': {
		id: 'legal.shipping.domesticShipping.standardShipping',
		defaultMessage: 'Free Standard Shipping:',
		description: 'Free Standard Shipping:',
	},
	'legal.shipping.domesticShipping.standardShippingTime': {
		id: 'legal.shipping.domesticShipping.standardShippingTime',
		defaultMessage:
			'3 to 7 days transit. Please note that order processing may take up to 2 business days after the order is placed for standard shipping.',
		description:
			'3 to 7 days transit. Please note that order processing may take up to 2 business days after the order is placed for standard shipping.',
	},
	'legal.shipping.domestic.priorityShipping': {
		id: 'legal.shipping.domestic.priorityShipping',
		defaultMessage: 'Priority:',
		description: 'Priority:',
	},
	'legal.shipping.domestic.priorityShippingTime': {
		id: 'legal.shipping.domestic.priorityShippingTime',
		defaultMessage:
			'1-3 days transit. The cost is calculated at the time of shipping. Please note that order processing may take up to 2 business days after the order is placed for standard shipping.',
		description:
			'1-3 days transit. The cost is calculated at the time of shipping. Please note that order processing may take up to 2 business days after the order is placed for standard shipping.',
	},
	'legal.shipping.country.ukEuropeCanada': {
		id: 'legal.shipping.country.ukEuropeCanada',
		defaultMessage: 'U.K., Europe and Canada',
		description: 'U.K., Europe and Canada',
	},
	'legal.shipping.international.standardShipping': {
		id: 'legal.shipping.international.standardShipping',
		defaultMessage: 'Standard International:',
		description: 'Standard International:',
	},
	'legal.shipping.international.standardShippingTime': {
		id: 'legal.shipping.international.standardShippingTime',
		defaultMessage:
			'14-21 days transit. The cost is calculated at checkout. Please note that order processing may take up to 2 business days after the order is placed for standard shipping.',
		description:
			'14-21 days transit. The cost is calculated at checkout. Please note that order processing may take up to 2 business days after the order is placed for standard shipping.',
	},
	'legal.shipping.international.trackedShipping': {
		id: 'legal.shipping.international.trackedShipping',
		defaultMessage: 'International Trackable:',
		description: 'International Trackable:',
	},
	'legal.shipping.international.trackedShippingTime': {
		id: 'legal.shipping.international.trackedShippingTime',
		defaultMessage:
			'For UK, 4-6 days transit. The cost is calculated at checkout. Please note that order processing may take up to 2 business days after the order is placed for standard shipping.',
		description:
			'For UK, 4-6 days transit. The cost is calculated at checkout. Please note that order processing may take up to 2 business days after the order is placed for standard shipping.',
	},
	'legal.shipping.content.1.4.0': {
		id: 'legal.shipping.content.1.4.0',
		defaultMessage:
			'Applicable sales tax will be charged where applicable. Taxes are calculated according to shipping destination and itemized on the Order Summary page.',
		description:
			'Applicable sales tax will be charged where applicable. Taxes are calculated according to shipping destination and itemized on the Order Summary page.',
	},
	'legal.shipping.content.2.1.0': {
		id: 'legal.shipping.content.2.1.0',
		defaultMessage:
			'Returns on eligible items are accepted within 30 days of order date. Items must be returned in their original packaging. To return an item, please contact {calmStore}.',
		description:
			'Returns on eligible items are accepted within 30 days of order date. Items must be returned in their original packaging. To return an item, please contact {calmStore}.',
	},
	'legal.shipping.content.2.2.0': {
		id: 'legal.shipping.content.2.2.0',
		defaultMessage: 'Any item returned after 40 days from order date is not eligible for refund.',
		description: 'Any item returned after 40 days from order date is not eligible for refund.',
	},
	'legal.shipping.content.2.3.0': {
		id: 'legal.shipping.content.2.3.0',
		defaultMessage:
			'A refund will be issued once we have received your returned items. Any items that are damaged when we receive them are not eligible for refund. Refunds do not include any shipping or handling charges, except in the case of faulty or damaged items. Your refund will be credited to the original form of payment used for the original transaction. Please note that credit card refunds may take up to 10 business day for your bank to complete, depending on their processing times.',
		description:
			'A refund will be issued once we have received your returned items. Any items that are damaged when we receive them are not eligible for refund. Refunds do not include any shipping or handling charges, except in the case of faulty or damaged items. Your refund will be credited to the original form of payment used for the original transaction. Please note that credit card refunds may take up to 10 business day for your bank to complete, depending on their processing times.',
	},
	'legal.shipping.content.3.1.0': {
		id: 'legal.shipping.content.3.1.0',
		defaultMessage:
			'If you have any questions about these Shipping Terms or Return Policy, please contact Calm at {calmStore}.',
		description:
			'If you have any questions about these Shipping Terms or Return Policy, please contact Calm at {calmStore}.',
	},
});
